import { APPSERVER_API_CONTENT_TYPE } from '@/main/app.constants';
import type { SeeqInternalAxiosRequestConfig } from '@/requests/axios.utilities';

type HttpInterceptorConfig = Pick<SeeqInternalAxiosRequestConfig, 'method'> & {
  headers: SeeqInternalAxiosRequestConfig['headers'] | Record<string, unknown>;
};

export function httpInterceptor<TConfig extends HttpInterceptorConfig>(config: TConfig): TConfig {
  // this is necessary as defining it on the axiosInstance does not work
  const method = config.method?.toLowerCase();
  if (method && ['post', 'put', 'patch'].includes(method)) {
    config.headers['content-type'] = APPSERVER_API_CONTENT_TYPE;
  }
  return config;
}
